import Search from '../header/Search';
import { useViewport } from 'developer-docs-shared-components/hooks/useViewport';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledSearch = styled.div.withConfig({
  displayName: "SearchPageInput__StyledSearch",
  componentId: "sc-132ovz5-0"
})(["display:block;margin-right:0px;padding-bottom:20px;"]);

/**
 * Created to conditionally insert the search input above the results
 * on the search page to correct a styling issue. Couldn't be done on \
 * the container, since the viewport context didn't exist.
 */
const SearchPageInput = () => {
  const {
    isMobile,
    isBelowLaptop
  } = useViewport();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isBelowLaptop && !isMobile && /*#__PURE__*/_jsx(StyledSearch, {
      children: /*#__PURE__*/_jsx(Search, {})
    })
  });
};
export default SearchPageInput;